import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const textColor = '#393939';
const primaryBlue = '#05164D';
const borderColor = primaryBlue;

const cellProperties = {
  padding: 2,
  paddingLeft: 4,
  fontSize: 8,
  color: textColor,
  alignSelf: 'stretch', 
  whiteSpace: 'break-spaces',
  fontFamily: 'NunitoRegular',
  borderRightColor: borderColor,
  borderRightWidth: 1,
};
const headProperties = {
  paddingRight: 2,
  paddingLeft: 4,
  fontSize: 8,
  color: 'white',
  textTransform: 'uppercase',
  whiteSpace: 'wrap',
  fontFamily: 'NunitoMedium',
  textAlign: 'left  ',
};

const styles = StyleSheet.create({
  headerContainer: { marginTop: 24, },
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 10,
  },
  container: {
    flexDirection: 'row',
    padding: '4px 2px',
    backgroundColor: primaryBlue,
    alignItems: 'center',
    flexGrow: 1,
  },
  title: {
    fontSize: 9,
    textTransform: 'uppercase',
    backgroundColor: '#f0f0f0',
    color: primaryBlue,
    padding: '4px 35px',
    textAlign: 'center',
    marginBottom: 5,
    lineHeight: 'normal',
    fontFamily: 'NunitoMedium',
    borderBottom: `2px solid ${primaryBlue}`,
  },
  tableRow: {
    flexDirection: 'row',
    alignItems: 'center',
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    minHeight: 16,
  },
  altRow: { backgroundColor: '#f5f5f5', },
  tableRowOuter: {
    flexDirection: 'column',
    borderBottomColor: borderColor,
    borderBottomWidth: 1,
  },
  header8: {
    ...headProperties,
    width: '8%',
  },
  cell8: {
    ...cellProperties,
    width: '8%',
  },
  header10: {
    ...headProperties,
    width: '10%',
  },
  cell10: {
    ...cellProperties,
    width: '10%',
  },
  header12: {
    ...headProperties,
    width: '13%',
  },
  cell12: {
    ...cellProperties,
    width: '13%',
  },
  header18: {
    ...headProperties,
    width: '18%',
  },
  cell18: {
    ...cellProperties,
    width: '18%',
  },
  header15: {
    ...headProperties,
    width: '15%',
  },
  cell15: {
    ...cellProperties,
    width: '15%',
  },
  header20: {
    ...headProperties,
    width: '20%',
  },
  cell20: {
    ...cellProperties,
    width: '20%',
  },
  header40: {
    ...headProperties,
    width: '40%',
  },
  cell40: {
    ...cellProperties,
    width: '40%',
  },
  noDataRow: {
    fontSize: 9,
    width: '100%',
    textAlign: 'center',
    padding: 4,
    color: textColor,
    fontFamily: 'NunitoRegular',
    borderColor: borderColor,
    borderWidth: 1,
  },
  remarks: {
    width: '100%',
    padding: 2,
    paddingTop: 2,
    fontSize: 8,
    color: textColor,
    borderRightColor: borderColor,
    borderRightWidth: 0,
    borderLeftWidth: 0,
    borderTop: '1px dashed lightgrey',
    fontFamily: 'NunitoRegular',
  },
  noBr: { borderRightWidth: 0, }
});


const Discrepancy = (props) => {
  const { discrepancy } = props;

  return (
    <View style={styles.headerContainer}>
      <Text style={styles.title}>List of Discrepancies</Text>
      <View style={styles.tableContainer}>

        <View style={styles.container}>
          <View style={styles.header12}><Text>Type</Text></View>
          <View style={styles.header15}><Text>ULD</Text></View>
          <View style={styles.header12}><Text>Handled As</Text></View>
          <View style={styles.header8}><Text>Seg</Text></View>
          <View style={styles.header20}><Text>AWB</Text></View>
          <View style={styles.header15}><Text>Prod</Text></View>
          <View style={styles.header8}><Text>O-D</Text></View>
          <View style={styles.header10}><Text>Dsc</Text></View>
        </View>

        {discrepancy && discrepancy.length > 0 ? 
          discrepancy?.map( item =>
            <View style={styles.tableRowOuter} key={item.id}>
              <View style={styles.tableRow} >
                <View style={styles.cell12}><Text>{item.type}</Text></View>
                <View style={styles.cell15}><Text>{item.uld_no} | {item.uld_type}</Text></View>
                <View style={styles.cell12}><Text>{item.handled_as}</Text></View>
                <View style={styles.cell8}><Text>{item.segment}</Text></View>
                <View style={styles.cell20}><Text>{item.awb_no} | {item.t_pcs}pcs | {item.t_wgt}</Text></View>
                <View style={styles.cell15}><Text>{item.products.map((product) => product.name).join(', ')}</Text></View>
                <View style={styles.cell8}><Text>{item.org} - {item.dest}</Text></View>
                <View style={styles.cell10}><Text>{item.d_pcs}pcs | {item.d_wgt}</Text></View>
              </View>
              <Text style={styles.remarks}>Remarks: {item?.remark || '-'}</Text>
            </View>

          ) : <View  style={styles.noDataRow}>
            <Text>No Data</Text>
          </View>}

      </View>
    </View>
  );
};
  
export default Discrepancy;